module.exports = __webpack_public_path__ + "img/facebook-icon.0da06d58.svg";